export enum RangeUnitType {
  CM = 'cm',
  MIN = 'min',
  METERS = 'm',
  INCHES = 'in',
  YARDS = 'yards',
}

export interface RangeInfo {
  min: number;
  max: number;
  value: number;
  units?: RangeUnitType;
  stepSize?: number;
  disabled?: boolean;
  invalidValue?: boolean;
}

export interface StartingPositionsOption {
  value: string;
  titleLangKey: string;
}

export interface StartingDistanceSettings extends RangeInfo {
  settingType: string;
  titleLangKey: string;
  descriptionLangKey: string;
}

export interface DrivePastWireSettings extends RangeInfo {
  settingType: string;
  titleLangKey: string;
  descriptionLangKey: string;
}

export interface StartingPoint {
  startPositionId: number;
  enabled: boolean;
  startPosition: string;
  passageCuttingEnabled: boolean;
  proportion: number;
  runningDistance: RangeInfo;
}

export interface LawnGuidanceSettings {
  settingType: string;
  titleLangKey: string;
  disabled?: boolean;
  invalidValue?: boolean;
  descriptionLangKey: string;
  startingPoints: StartingPoint[];
}

export interface GpsNavigationSettings {
  settingType: string;
  enabled: boolean;
  invalidValue?: boolean;
}

export interface LoopWireRangeInfo extends RangeInfo {
  loopWire: string;
}

export interface CorridorWidthSettings {
  settingType: string;
  titleLangKey: string;
  descriptionLangKey: string;
  boundary: RangeInfo;
  guides: LoopWireRangeInfo[];
}

export interface LoopWireToggle {
  loopWire: string;
  enabled: boolean;
}

export interface StationSignalOption {
  value: string;
  titleLangKey: string;
  selected: boolean;
}

export interface SearchChargingStationBoundarySettings extends RangeInfo {
  enabled: boolean;
}

export interface SearchChargingStationGuideSettings extends RangeInfo {
  enabled: boolean;
  loopWire: string;
}

export interface SearchChargingStationSettings {
  settingType: string;
  titleLangKey: string;
  descriptionLangKey: string;
  signal: StationSignalOption[];
  boundary: SearchChargingStationBoundarySettings;
  guides: SearchChargingStationGuideSettings[];
  disabled?: boolean;
  invalidValue?: boolean;
}

/* Representation of the received installation settings state */
export interface RoboticInstallationSettings {
  loopWires: StartingPositionsOption[];
  gpsNavigation?: GpsNavigationSettings;
  lawnGuidance?: LawnGuidanceSettings;
  startingDistance?: StartingDistanceSettings;
  drivePastWire?: DrivePastWireSettings;
  corridorWidth?: CorridorWidthSettings;
  searchChargingStation?: SearchChargingStationSettings;
}

/* Payload for startingDistance & drivePastWire */
export interface SingleRangePayload {
  value: number;
}

/* Payload for corridorWidth */
export interface CorridorWidthGuidePayload {
  value: number;
  loopWire: string;
}

export interface CorridorWidthPayload {
  boundary: number;
  guides: CorridorWidthGuidePayload[];
}

/* Payload for searchChargingStation */
export interface SearchChargingStationPayload {
  signal: string;
  boundary: {
    value: number;
    enabled: boolean;
  };
  guides: {
    enabled: boolean;
    value: number;
    loopWire: string;
  }[];
}

/* Payload for lawnGuidance */
export interface LawnGuidanceStartingPointPayload {
  enabled: boolean;
  startPosition: string;
  passageCuttingEnabled: boolean;
  proportion: number;
  runningDistance: number;
  startPositionId: number;
}
export interface LawnGuidancePayload {
  startingPoints: LawnGuidanceStartingPointPayload[];
}

export interface SettingsMapItem {
  code: string;
  image: string;
  titleLangKey: string;
  descriptions: string[];
}

export interface GpsNavigationPayload {
  enabled: boolean;
}
